import axios from "axios";
// import { cloneDeep } from "lodash";

/* -------------------- MODULE-LEVEL FLAG -------------------- */
// Used to prevent duplicate calls for the same reportId
let loadedReportIds = new Set();
let loadingReportIds = new Set();

/* -------------------- INITIAL STATE -------------------- */
const INITIAL_STATE = {
  reportSubscriptions: [],
  searchUsers: [],
  loading: false,
  error: null,
};

/* -------------------- ACTION TYPES -------------------- */
const FETCH_RPT_SUBS_BEGIN = "FETCH_RPT_SUBS_BEGIN";
const FETCH_RPT_SUBS_SUCCESS = "FETCH_RPT_SUBS_SUCCESS";
const FETCH_RPT_SUBS_FAILURE = "FETCH_RPT_SUBS_FAILURE";
const SET_SELECT_ALL = "SET_SELECT_ALL";
const SET_SELECTED_VALUE = "SET_SELECTED_VALUE";

/* -------------------- ACTION CREATORS -------------------- */

const fetchReportSubscriptionsBegin = () => ({
  type: FETCH_RPT_SUBS_BEGIN,
});
const fetchReportSubscriptionsSuccess = (users) => {
  return { type: FETCH_RPT_SUBS_SUCCESS, payload: users };
};
const fetchReportSubscriptionsError = (error) => ({
  type: FETCH_RPT_SUBS_FAILURE,
  payload: { error },
});

/* -------------------- ASYNC ACTION CREATORS -------------------- */

export const getReportSubscriptions = (loading = true, reportId = null, user = null) => {
  return (dispatch) => {
    // Prevent duplicate calls for the same reportId
    const key = reportId || "all";
    // console.log(
    //   "[getReportSubscriptions] Check - key:",
    //   key,
    //   "loading:",
    //   loadingReportIds.has(key),
    //   "loaded:",
    //   loadedReportIds.has(key),
    // );
    if (loadingReportIds.has(key) || loadedReportIds.has(key)) {
      // console.log("[getReportSubscriptions] BLOCKED - already loading or loaded");
      return;
    }
    // console.log("[getReportSubscriptions] PROCEEDING - adding to loading set");
    loadingReportIds.add(key);
    if (loading) dispatch(fetchReportSubscriptionsBegin());
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/powerBI/getReportSubscriptions`,
        {
          reportId,
          user,
          // client: client
          //idToken: localStorage.getItem("id_token")
        },
        {
          headers: {
            //Authorization: "Bearer " + localStorage.getItem("access_token")
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        // console.log("[getReportSubscriptions] SUCCESS - moving to loaded set");
        loadingReportIds.delete(key);
        loadedReportIds.add(key);
        dispatch(fetchReportSubscriptionsSuccess(response.data.subscriptions));
      })
      .catch((error) => {
        // console.log("[getReportSubscriptions] ERROR - removing from loading set");
        loadingReportIds.delete(key);
        dispatch(fetchReportSubscriptionsError(error));
      });
  };
};

export const saveReportSubscription = (rptSub, update = false, reportId = null, user = null) => {
  return (dispatch) => {
    // dispatch(fetchReportSubscriptionsBegin());
    if (update) {
      axios
        .post(
          `${process.env.REACT_APP_BIGHORN_SERVER}/api/powerBI/updateReportSubscription`,
          {
            rptSub,
            // client: client
            //idToken: localStorage.getItem("id_token")
          },
          {
            headers: {
              //Authorization: "Bearer " + localStorage.getItem("access_token")
              ClientToken: localStorage.getItem("clientToken"),
            },
          },
        )
        .then((response) => {
          console.log("Saved");

          dispatch(getReportSubscriptions(false, reportId, user));

          // dispatch(fetchReportSubscriptionsSuccess(response.data.subscriptions));
        })
        .catch((error) => dispatch(fetchReportSubscriptionsError(error)));
    } else {
      axios
        .post(
          `${process.env.REACT_APP_BIGHORN_SERVER}/api/powerBI/saveReportSubscription`,
          {
            rptSub,
            // client: client
            //idToken: localStorage.getItem("id_token")
          },
          {
            headers: {
              //Authorization: "Bearer " + localStorage.getItem("access_token")
              ClientToken: localStorage.getItem("clientToken"),
            },
          },
        )
        .then((response) => {
          console.log("Saved");
          dispatch(getReportSubscriptions(false, reportId, user));
          // dispatch(fetchReportSubscriptionsSuccess(response.data.subscriptions));
        })
        .catch((error) => dispatch(fetchReportSubscriptionsError(error)));
    }
  };
};
export const deleteReportSubscription = (rptSubId, reportId = null, user = null) => {
  return (dispatch) => {
    // dispatch(fetchReportSubscriptionsBegin());

    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/powerBI/deleteReportSubscription`,
        {
          rptSubId,
          // client: client
          //idToken: localStorage.getItem("id_token")
        },
        {
          headers: {
            //Authorization: "Bearer " + localStorage.getItem("access_token")
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        console.log("Deleted");
        dispatch(getReportSubscriptions(false, reportId, user));
        // dispatch(fetchReportSubscriptionsSuccess(response.data.subscriptions));
      })
      .catch((error) => dispatch(fetchReportSubscriptionsError(error)));
  };
};
export const selectAllSubscriptions = (selectAll) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECT_ALL, payload: selectAll });
  };
};
export const selectSubscription = (subId, select) => {
  return (dispatch) => {
    dispatch({ type: SET_SELECTED_VALUE, payload: select, subId });
  };
};

/* -------------------- REDUCER -------------------- */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_RPT_SUBS_BEGIN:
      return { ...state, loading: true, error: null };
    case FETCH_RPT_SUBS_SUCCESS:
      return {
        ...state,
        users: action.payload,
        reportSubscriptions: action.payload,
        loading: false,
      };

    case FETCH_RPT_SUBS_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case SET_SELECTED_VALUE:
      let selectRptSubs = state.reportSubscriptions;

      selectRptSubs = selectRptSubs.map((item) => {
        if (item._id === action.subId) {
          item.selected = action.payload;
        }
        return item;
      });

      return { ...state, reportSubscriptions: selectRptSubs };
    case SET_SELECT_ALL:
      let newRptSubs = state.reportSubscriptions;

      newRptSubs = newRptSubs.map((item) => {
        item.selected = action.payload;
        return item;
      });

      return { ...state, reportSubscriptions: newRptSubs };

    default:
      return state;
  }
};
